import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { TALENT, TALENT_ID } from '../../data/define';
import { intelligencesOrdering } from '../../utility/intelligencesOrdering';
import { useTranslation } from '../../hook/useTranslation';
// import EmptyCase from '../common/EmptyCase';

const order = [
  TALENT_ID.RELATIONSHIP,
  TALENT_ID.LANGUAGE,
  TALENT_ID.MATH,
  TALENT_ID.PHYSICAL,
  TALENT_ID.REFLECTION,
  TALENT_ID.NATURE,
  TALENT_ID.SPACE,
  TALENT_ID.MUSIC,
];

function MultiIntelligenceBar({ result = [] }) {
  const { t, locale } = useTranslation();
  // const [emptyOpen, setEmptyOpen] = useState(false);
  const [series, setSeries] = useState([
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0],
    },
  ]);
  const [originalScores, setOriginalScores] = useState([]);

  useEffect(() => {
    if (result) {
      const resultMap = new Map(result.map((item) => [item.id, item]));
      const orderedResult = order.map((id) => {
        return resultMap.has(id) ? resultMap.get(id) : { id, score: 0 };
      });
      const reorderedResult = intelligencesOrdering(order, orderedResult);
      const scores = reorderedResult.map((item) => item.score || 0);
      setOriginalScores(scores);
      setSeries([
        {
          data: scores.map((score) => (score === 0 ? 10 : score)),
        },
      ]);
    }
  }, [result]);

  // emptyCase set
  // useEffect(() => {
  //   const hasData = result?.filter(
  //     (item) => item.score !== undefined && item.score !== null
  //   )?.length;
  //   if (hasData < 4) {
  //     setEmptyOpen(true);
  //   } else {
  //     setEmptyOpen(false);
  //   }
  // }, [result]);

  const options = {
    chart: {
      height: 200,
      type: 'bar',
      offsetX: 0,
      offsetY: 0,
      toolbar: {
        show: false,
      },
    },
    colors: originalScores.map((score) => (score === 0 ? '#CCCCCC' : '#76DFE1')),
    grid: {
      show: false,
      padding: {
        left: 10,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        dataLabels: { position: 'top' },
        distributed: true,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, { dataPointIndex }) => {
        return originalScores[dataPointIndex] === 0 ? '' : val;
      },
      offsetY: 0,
      style: { fontSize: '12px', colors: ['#fff'] },
    },
    xaxis: {
      categories: [
        t('talent.' + TALENT.RELATIONSHIP.key),
        t('talent.' + TALENT.LANGUAGE.key),
        t('talent.' + TALENT.MATH.key),
        t('talent.' + TALENT.PHYSICAL.key),
        t('talent.' + TALENT.REFLECTION.key),
        t('talent.' + TALENT.NATURE.key),
        t('talent.' + TALENT.SPACE.key),
        t('talent.' + TALENT.MUSIC.key),
      ],
      labels: {
        rotate: -45, // 회전 각도 허용
        rotateAlways: false, // 겹칠 때만 회전하도록 설정 (공간 충분하면 수평 유지)
        hideOverlappingLabels: false,
        trim: true, // 너무 길면 자르기 허용
        minHeight: 60, // 레이블이 회전할 때 잘리지 않도록 높이 확보
        style: {
          fontSize: locale === 'en' ? '8px' : '9px', // 영어일 때 폰트 더 작게
          colors: ['#333'],
        },
      },
      position: 'bottom',
      axisBorder: { show: false },
      axisTicks: { show: false },
      tooltip: { enabled: false },
    },
    yaxis: {
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: false,
        formatter: (val) => val,
      },
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          xaxis: {
            labels: {
              rotateAlways: true,
            },
          },
        },
      },
    ],
  };

  return (
    <div className="w-full relative pt-[20px] pb-[10px]">
      <div className="w-full flex items-center justify-start gap-1 mb-[-10px]">
        <div className="text-[#1C1C1C] font-[700] text-[20px] text-left">
          {t('report.score_analysis.title')}
        </div>
      </div>
      <ReactApexChart options={options as any} series={series} type="bar" height={350} />
      {/* <EmptyCase open={emptyOpen} text="다중지능 점수 분석" /> */}
    </div>
  );
}

export default MultiIntelligenceBar;
